<template>
  <div>
    <div id="reset-wrapper"><a @click="showConfirm = true"><img src="../../assets/images/icons/home.png" class="full-logo"></a></div>
    <ConfirmReset v-if="showConfirm" @close="showConfirm = false"></ConfirmReset>
    <div class="m-background m-background--media-1"></div>
    <div class="l-container l-pad">
        <div class="survey">
        <p><strong>Which aspect from today's session have you found most useful?</strong></p>
        <div class="feedback">
          <textarea v-model="response" cols="80" rows="20"></textarea>
        </div>
      </div>
      <a @click="answerFeedback(response)" class="m-btn m-btn--left m-btn__primary">Continue &nbsp;<span class="m-btn__arrow" style="display:inline-block; margin-top: -0.4em;"></span></a>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MainFooter from '../../components/MainFooter'
import Brand from '../../components/Brand'
import ConfirmReset from '../../components/ConfirmReset'
export default {
  data () {
    return {
      response: '',
      showConfirm: false
    }
  },
  computed: {
    ...mapGetters(['getScore', 'getStudentByName']),
    highScore () {
      let scoreArray = this.getScore
      var res = Math.max.apply(Math, scoreArray.map(function (o) { return o.score }))
      var obj = scoreArray.find(function (o) { return o.score === res })
      return obj
    },
    student () {
      let student = this.highScore.name
      return this.getStudentByName(student)
    }
  },
  components: {
    MainFooter,
    Brand,
    ConfirmReset
  },
  methods: {
    ...mapActions(['updateFeedback']),
    answerFeedback (answer) {
      this.updateFeedback({key: 'mostUsefulAspect', val: answer})
      this.$router.push({ name: 'result', params: { id: this.student.name } })
    }
  },
  name: 'UserFeedback4'
}
</script>

<style scoped lang='scss'>
p {font-size:170%;width:60%;margin:10px auto 20px auto;}
.m-btn__options {padding:10px 20px;postion:relative;font-size:100%;}
.survey {margin-top:100px;text-align:center;}
textarea {/*box-shadow: 0px 0px 10px rgba(0,0,0,0.16);border:1px solid #a1a1a1;*/
  padding: 10px;border-radius: 8px;
  border: none;
}

@media (max-width: 899px) {
    .survey {margin-top:35px;font-size:70%;}
    .feedback {margin:15px 0;}
    textarea {width:80%;height:80px;}
  }
  @media (min-width: 900px) {
    textarea {width:80%;height:100px;}
  }
  @media (min-width: 1200px) {
    textarea {width:80%;height:200px;}
  }
  a.m-btn__options {cursor:pointer;}
</style>



// WEBPACK FOOTER //
// src/views/Survey/UserFeedback4.vue